import * as React from 'react';
import { SVGProps } from 'react';

const IconLaptopStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2Zm10 7H0v1h12V9Z"
    />
  </svg>
);
export default IconLaptopStrokedSizeXs;
